import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { NEWS_LIST_PAGE_PATH } from '../../pages/Content/News/constants/path'

import { NewsMoreLinkProps } from './interface'

export const NewsMoreLink = ({
  catalogueId,
  catalogueCode
}: NewsMoreLinkProps) => {
  return (
    <NavigateButton
      newtab
      type='link'
      to={stringifyUrl({
        url: NEWS_LIST_PAGE_PATH,
        query: { catalogueId, catalogueCode }
      })}
    >
      更多&gt;
    </NavigateButton>
  )
}
